import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SubscriptionDialogData {
  subscriptionType: 'moneyball' | 'people' | 'chat';
}

@Component({
    selector: 'app-subscription-dialog',
    templateUrl: './subscription-dialog.component.html',
    styleUrls: ['./subscription-dialog.component.scss'],
    standalone: false
})
export class SubscriptionDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SubscriptionDialogData,
    private dialogRef: MatDialogRef<SubscriptionDialogComponent>
  ) {}

  ngOnInit(): void {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
